import React from 'react';
import PropTypes from 'prop-types';
import { ResponsiveImage } from '@web/molecules/index.js';
import { StatBadge } from '@web/atoms';
import {
  StyledQuizCallout,
  Headline,
  Subheadline,
  Attribute,
  Content,
} from './styles.js';

const WIDGET_CALLOUT_PROPS = {
  $borderRadius: '24px',
  $minHeight: '100px',
  $margin: [0, 0],
};

export const QuizCallout = ({
  headline,
  subheadline,
  attribute,
  icon,
  badge,
  fontColor = 'secondary.plum',
  backgroundColor = 'background.lightest',
  hideCallout = false,
  margin = [6, 0],
  borderRadius = '10px',
}) => {
  return (
    <StyledQuizCallout
      $hideCallout={hideCallout}
      $bgColor={backgroundColor}
      $fontColor={fontColor}
      $margin={margin}
      $borderRadius={borderRadius}
      {...(badge ? WIDGET_CALLOUT_PROPS : null)}
    >
      {badge ? (
        <StatBadge {...badge} />
      ) : (
        icon && (
          <ResponsiveImage
            src={icon.src}
            alt={icon.alt}
            height={48}
            width={48}
          ></ResponsiveImage>
        )
      )}
      <Content>
        {headline && <Headline>{headline}</Headline>}
        {subheadline && (
          <Subheadline $usePrimaryText={Boolean(badge)}>
            {subheadline}
          </Subheadline>
        )}
        {attribute && <Attribute>{attribute}</Attribute>}
      </Content>
    </StyledQuizCallout>
  );
};
QuizCallout.displayName = 'QuizCallout';

QuizCallout.propTypes = {
  headline: PropTypes.string,
  subheadline: PropTypes.string,
  attribute: PropTypes.string,
  icon: PropTypes.object,
  badge: PropTypes.shape({
    stat: PropTypes.number,
    icon: PropTypes.object,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
    size: PropTypes.number,
  }),
  fontColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  hideCallout: PropTypes.bool,
  margin: PropTypes.arrayOf(PropTypes.number),
  borderRadius: PropTypes.string,
};
